// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tooltip-label_wrapper__R2cQI","holder":"tooltip-label_holder__jK7tP"};